/**
 * 诊所配置模块路由配置
 *
 * @module clinic-config/routes
 */
import { RouteRecordRaw } from "vue-router";

const ClinicConfigView = () => import("./interfaces/ClinicConfigView.vue");

export const clinicConfigRoutes: RouteRecordRaw[] = [
  {
    path: "/clinic-config",
    name: "ClinicConfig",
    component: ClinicConfigView,
    meta: {
      title: "诊所配置",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "诊所配置"],
    },
  },
];

export default clinicConfigRoutes;
